
export default {
    data () {
        return {
            isLoadingExcel: false
        }
    },
    computed: {
        getIconForExcelExport () {
            if (this.isLoadingExcel) {
                return 'spinner8 spinner'
            }
            return 'download3'
        },
    },
    methods: {
        async downloadExcel (tab) {
            this.isLoadingExcel = true
            const excelToastTemplate = (
                <div class="courses__download-toast-container">
                    <h3 class="courses__download-toast-title"><span class="icon-download3"></span>{this.$t('OrganizationReport.excel_notification_title')}</h3>
                    <span class="courses__download-toast-text">{this.$t('OrganizationReport.excel_notification_text')}</span>
                </div>
            )
            this.$toast(excelToastTemplate, {
                position: 'top-right',
                timeout: 7000,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                rtl: false,
                icon: false,
                toastClassName: 'toast-container'
            })
            await this.$store.dispatch(`Reports${tab}/load${tab}ReportingExcel`)
            this.isLoadingExcel = false
        },
    }
}
